var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataCache } from '../../DataCache';
import { OrderFormatter } from '../../cache/Formatters/OrderFormatter';
import { TvInteriorIdCache } from '../Caches/TvInteriorIdCache';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { TvOrderConvertor } from '../Convertors/TvOrderConvertor';
import { DirectOpenOrderMessage } from '@shared/utils/DirectMessages/DirectOpenOrderMessage';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
import { SlTpHolder } from '@shared/utils/Trading/SlTpHolder';
import { SlTpPriceType } from '@shared/utils/Enums/Constants';
import { PositionEdit } from '../../cache/OrderParams/PositionEdit';
import { TvSlTpCache, TvSlTpModificationType } from '../Caches/TvSlTpCache';
import { DirectOrderDialogMessage } from '@shared/utils/DirectMessages/DirectOrderDialogMessage';
import { LOCALE_EN, Resources } from '@shared/localizations/Resources';
import { OrderUtils } from '@shared/utils/Trading/OrderUtils';
import { OrderExecutionType } from '@shared/utils/Trading/OrderExecutionType';
import { TvDurationConvertor } from '../Convertors/TvDurationConvertor';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
import { DirectReportMessage } from '@shared/utils/DirectMessages/DirectReportMessage';
export class TvOrdersManager {
    constructor(host) {
        this.host = host;
        this.subscribeEvents();
    }
    getOrders() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const rOrders = DataCache.Trading.getOrdersByAccount(TvAccountHelper.getCurrentAccount());
                let orders = [];
                for (const rOrder of rOrders) {
                    if (!this.isOrderAllowed(rOrder))
                        continue;
                    const tvOrders = this.convertToTvOrders(rOrder);
                    if (tvOrders.length === 0) {
                        continue;
                    }
                    orders = [...orders, ...tvOrders];
                }
                resolve(orders);
            });
        });
    }
    placeOrder(preOrder, confirmId) {
        return __awaiter(this, void 0, void 0, function* () {
            const orderEditBase = TvOrdersManager.createOrderEditBase(preOrder, TvAccountHelper.getCurrentAccount());
            const res = yield DataCache.FOrderExecutor.placeOrderAsync(orderEditBase);
            let orderId = null;
            if (res instanceof DirectOpenOrderMessage) {
                const directOpenOrderMessage = res;
                orderId = directOpenOrderMessage.OrderNumber;
            }
            else if (res instanceof DirectOrderDialogMessage) {
                const directOrderDialogMessage = res;
                orderId = directOrderDialogMessage.OrderId;
            }
            if (!isNullOrUndefined(orderId)) {
                const correctResult = { orderId };
                return yield Promise.resolve(correctResult);
            }
            else if (res instanceof DirectReportMessage) {
                const errorMsg = Resources.getResource('BusinessRejectMessage.' + res.BusinessRejectCode);
                const error = new Error(errorMsg);
                return yield Promise.reject(error);
            }
            else {
                const incorrrectResult = {};
                return yield Promise.resolve(incorrrectResult); // Promise.reject: TV dispays info: please contact your broker
            }
        });
    }
    modifyOrder(tvOrder, confirmId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (tvOrder.parentType === 2 /* ParentType.Position */ && !isNullOrUndefined(tvOrder.parentId)) {
                const position = DataCache.Trading.getPositionById(tvOrder.parentId);
                if (isNullOrUndefined(position)) {
                    yield Promise.reject(new Error(`position not found ${tvOrder.parentId}`));
                    return;
                }
                if (!this.isValidPositionBrackets(position, tvOrder)) {
                    yield Promise.reject(new Error('Is not possible to modify Quantity and Tif for position bracket'));
                    return;
                }
                yield this.modifyPositionBracket(position, tvOrder);
                return;
            }
            const orderId = tvOrder.id;
            if (TvSlTpCache.isSlId(orderId)) {
                const rOrder = DataCache.Trading.getOrderById(tvOrder.parentId);
                if (isNullOrUndefined(rOrder)) {
                    yield Promise.reject(new Error(`order not found ${tvOrder.parentId}`));
                    return;
                }
                if (!this.isValidOrderBrackets(rOrder, tvOrder)) {
                    yield Promise.reject(new Error('Is not possible to modify Quantity and Tif for order bracket'));
                    return;
                }
                yield this.modifySLOrder(rOrder, tvOrder, confirmId);
                return;
            }
            if (TvSlTpCache.isTpId(orderId)) {
                const rOrder = DataCache.Trading.getOrderById(tvOrder.parentId);
                if (isNullOrUndefined(rOrder)) {
                    yield Promise.reject(new Error(`order not found ${tvOrder.parentId}`));
                    return;
                }
                if (!this.isValidOrderBrackets(rOrder, tvOrder)) {
                    yield Promise.reject(new Error('Is not possible to modify Quantity and Tif for order bracket'));
                    return;
                }
                yield this.modifyTPOrder(tvOrder, confirmId);
                return;
            }
            const rOrder = DataCache.Trading.getOrderById(tvOrder.id);
            if (isNullOrUndefined(rOrder)) {
                yield Promise.resolve();
                return;
            }
            const orderEditBase = this.getOrderTypeObject(rOrder);
            const sltpHolder = new SlTpHolder(); // this.getSlTpHolder(rOrder);
            if (!isNullOrUndefined(tvOrder.takeProfit)) {
                sltpHolder.TakeProfitPriceType = SlTpPriceType.Absolute;
                sltpHolder.TakeProfitPriceValue = tvOrder.takeProfit;
            }
            if (!isNullOrUndefined(tvOrder.stopLoss)) {
                if (isValidNumber(tvOrder.trailingStopPips)) // StopType.TrailingStop
                 {
                    sltpHolder.StopLossPriceType = SlTpPriceType.TrOffset;
                    sltpHolder.StopLossPriceValue = tvOrder.trailingStopPips;
                }
                else {
                    sltpHolder.StopLossPriceType = SlTpPriceType.Absolute;
                    sltpHolder.StopLossPriceValue = tvOrder.stopLoss;
                }
            }
            TvOrdersManager.fillOrderEditBase(orderEditBase, TvAccountHelper.getCurrentAccount(), tvOrder, sltpHolder);
            yield DataCache.FOrderExecutor.modifyOrderPromise(orderEditBase);
        });
    }
    cancelOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (TvSlTpCache.isSlId(orderId)) {
                yield this.cancelSlOrder(orderId);
                return;
            }
            if (TvSlTpCache.isTpId(orderId)) {
                yield this.cancelTpOrder(orderId);
                return;
            }
            yield this.cancelOrders('', 1 /* Side.Buy */, [orderId], PlacedFrom.TV_TRADING_PLATFORM_OTHER);
        });
    }
    cancelOrders(symbol, side, ordersIds, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve, reject) => {
                // hsa: сюда заходят и SL и TP ордера
                // но не думаю что их нужно отменять отдельно, поэтому просто пропускаю
                const ordersWithouSlTp = ordersIds.filter((orderId) => !TvSlTpCache.isSlId(orderId) && !TvSlTpCache.isTpId(orderId));
                const orderDict = DataCache.Trading.getOrdersById(ordersWithouSlTp);
                DataCache.FOrderExecutor.cancelSelectedOrders(orderDict, placedFrom);
                resolve();
            });
        });
    }
    editPositionBrackets(positionId, brackets, customFields) {
        return __awaiter(this, void 0, void 0, function* () {
            const position = DataCache.Trading.getPositionById(positionId);
            if (!position) {
                yield Promise.reject(new Error(`position not found ${positionId}`));
                return;
            }
            const positionEdit = new PositionEdit({
                dataCache: position.DataCache,
                position,
                placedFrom: PlacedFrom.TV_TRADING_PLATFORM_OE
            });
            const hasSlTrailingStop = !isNullOrUndefined(brackets.trailingStopPips);
            const hasSl = !isNullOrUndefined(brackets.stopLoss);
            const hasTp = !isNullOrUndefined(brackets.takeProfit);
            const slTpHolder = new SlTpHolder();
            if (hasSlTrailingStop || hasSl) {
                if (hasSlTrailingStop) {
                    slTpHolder.StopLossPriceType = SlTpPriceType.TrOffset;
                    slTpHolder.StopLossPriceValue = brackets.trailingStopPips;
                }
                else {
                    slTpHolder.StopLossPriceType = SlTpPriceType.Absolute;
                    slTpHolder.StopLossPriceValue = brackets.stopLoss;
                }
            }
            if (hasTp) {
                slTpHolder.TakeProfitPriceType = SlTpPriceType.Absolute;
                slTpHolder.TakeProfitPriceValue = brackets.takeProfit;
            }
            positionEdit.setSLTP({ sltpHolder: slTpHolder });
            yield DataCache.FOrderExecutor.WMmodifyPositionPromise(positionEdit);
        });
    }
    updateOrders() {
        const rOrders = DataCache.Trading.getOrdersByAccount(TvAccountHelper.getCurrentAccount());
        for (const rOrder of rOrders) {
            if (!this.isOrderAllowed(rOrder))
                continue;
            const tvOrders = this.convertToTvOrders(rOrder);
            for (const tvOrder of tvOrders) {
                this.orderPartialUpdate(rOrder, tvOrder);
            }
        }
    }
    modifyPositionBracket(position, tvOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const positionEdit = new PositionEdit({
                dataCache: position.DataCache,
                position,
                placedFrom: PlacedFrom.TV_TRADING_PLATFORM_OE
            });
            const sltpDynPropety = positionEdit.toDynProperty_sltp();
            const isTp = tvOrder.type === 1 /* tvOrderType.Limit */;
            if (isTp) {
                sltpDynPropety.tp.enabled = true;
                sltpDynPropety.tp.value = tvOrder.limitPrice;
            }
            else {
                const isTrailingStop = tvOrder.stopType === 1; // StopType.TrailingStop
                sltpDynPropety.sl.enabled = true;
                sltpDynPropety.trailingStop.enabled = isTrailingStop;
                if (isTrailingStop) {
                    sltpDynPropety.trailingStop.value = tvOrder.trailingStopPips;
                }
                else {
                    sltpDynPropety.sl.value = tvOrder.stopPrice;
                }
            }
            positionEdit.updateParameters(new OrderEditUpdateData({ sltp: sltpDynPropety }));
            yield DataCache.FOrderExecutor.WMmodifyPositionPromise(positionEdit);
        });
    }
    getSymbol(order) {
        // const symbol = order.Instrument.DisplayName();
        // return TvInteriorIdCache.getInteriorId(symbol);
        return TvSymbolConvertor.getFullname(order.Instrument);
    }
    getTvOrderType(rOrder) {
        const rOrderType = OrderFormatter.OrderType(rOrder);
        return TvOrderConvertor.getTvOrderType(rOrderType);
    }
    getTvOrderStatus(rOrder) {
        const rOrderStatus = OrderFormatter.OrderStatus(rOrder);
        return TvOrderConvertor.getTvOrderStatus(rOrderStatus);
    }
    getTvOrderSide(rOrder) {
        return TvOrderConvertor.getTvOrderSide(rOrder.BuySell);
    }
    InvertSide(side) {
        return side === 1 /* Side.Buy */ ? -1 /* Side.Sell */ : 1 /* Side.Buy */;
    }
    getTvOrderDuration(order) {
        const tif = order.TimeInForce;
        const expiration = order.ExpireAt;
        return TvOrderConvertor.getTvOrderDuration(tif, expiration);
    }
    convertToTvOrders(rOrder) {
        if (rOrder.isClosingOrder()) {
            const position = DataCache.Trading.getPositionById(rOrder.PositionId);
            if (isNullOrUndefined(position)) {
                return [];
            }
            const rOrderType = rOrder.OrderType;
            const isTP = rOrderType === OrderType.Limit;
            if (isTP && !isNullOrUndefined(position.TPOrder)) {
                const tvTpOrder = this.createTpBracketForPosition(position);
                return [tvTpOrder];
            }
            const isSL = rOrderType === OrderType.Stop ||
                rOrderType === OrderType.StopLimit ||
                rOrderType === OrderType.TrailingStop;
            if (isSL && !isNullOrUndefined(position.SLOrder)) {
                const tvSlOrder = this.createSlBracketForPosition(position);
                return [tvSlOrder];
            }
        }
        const rOrderType = OrderFormatter.OrderType(rOrder);
        const tvOrder = {
            id: rOrder.OrderNumber,
            symbol: this.getSymbol(rOrder),
            type: this.getTvOrderType(rOrder),
            side: this.getTvOrderSide(rOrder),
            qty: OrderFormatter.Amount(rOrder),
            status: this.getTvOrderStatus(rOrder),
            updateTime: OrderFormatter.DateTime(rOrder).getTime(),
            filledQty: OrderFormatter.QuantityFilled(rOrder),
            avgPrice: OrderFormatter.AverageFilledPrice(rOrder),
            duration: this.getTvOrderDuration(rOrder)
        };
        if (rOrderType === OrderType.Market) {
            tvOrder.limitPrice = OrderFormatter.Price(rOrder);
        }
        else if (rOrderType === OrderType.Limit || rOrderType === OrderType.SLTPLimit) {
            tvOrder.limitPrice = OrderFormatter.Price(rOrder);
        }
        else if (rOrderType === OrderType.Stop || rOrderType === OrderType.SLTPStop) {
            tvOrder.stopPrice = OrderFormatter.Price(rOrder);
            tvOrder.stopType = 0; // StopType.Stop
        }
        else if (rOrderType === OrderType.StopLimit) {
            tvOrder.limitPrice = OrderFormatter.Price(rOrder);
            tvOrder.stopPrice = OrderFormatter.StopPrice(rOrder);
        }
        else if (rOrderType === OrderType.TRStop) {
            tvOrder.stopPrice = OrderFormatter.Price(rOrder); // TODO
            tvOrder.stopType = 1; // StopType.TrailingStop
        }
        const tvOrderSl = this.createStopLossBracket(rOrder);
        const tvOrderTp = this.createTakeProfitBracket(rOrder);
        const tvOrders = [];
        tvOrders.push(tvOrder);
        if (tvOrderSl !== null) {
            if (!isNullOrUndefined(tvOrderSl.stopPrice)) {
                tvOrder.stopLoss = tvOrderSl.stopPrice;
            }
            if (!isNullOrUndefined(tvOrderSl.trailingStopPips)) {
                tvOrder.trailingStopPips = tvOrderSl.trailingStopPips;
            }
            const isTrailingStop = OrderFormatter.IsStopLossTrailingStop(rOrder);
            let slModType = TvSlTpModificationType.WithoutChanges;
            if (isTrailingStop) {
                slModType = TvSlTpCache.insertSlTrailingStopPrice(rOrder.OrderNumber, tvOrder.stopLoss, tvOrder.trailingStopPips);
            }
            else {
                slModType = TvSlTpCache.insertSlPrice(rOrder.OrderNumber, tvOrder.stopLoss);
            }
            // if (slModType === TvSlTpModificationType.New || slModType === TvSlTpModificationType.ModifyOrder) {
            tvOrders.push(tvOrderSl);
            // } else if (slModType === TvSlTpModificationType.Replace) {
            //    throw new Error('TvSlTpModificationType.Replace');
            // TODO: cancel prev order and place new?
            // }
        }
        if (tvOrderTp !== null) {
            tvOrder.takeProfit = tvOrderTp.limitPrice;
            const tpModType = TvSlTpCache.insertTpPrice(rOrder.OrderNumber, tvOrder.takeProfit);
            // if (tpModType === TvSlTpModificationType.New || tpModType === TvSlTpModificationType.ModifyOrder) {
            tvOrders.push(tvOrderTp);
            // }
        }
        if (tvOrder.status === 5 /* tvOrderStatus.Rejected */) {
            const msg = {
                type: 'error',
                text: rOrder.Comment
            };
            for (const tvOrder of tvOrders) {
                tvOrder.message = msg;
            }
        }
        return tvOrders;
    }
    subscribeEvents() {
        DataCache.OnAddOrder.Subscribe(this.onAddOrUpdateOrderEvent, this);
        DataCache.OnUpdateOrder.Subscribe(this.onAddOrUpdateOrderEvent, this);
        DataCache.OnRemoveOrder.Subscribe(this.onRemoveOrderEvent, this);
        DataCache.OnAddSLOrderToPosition.Subscribe(this.onAddSLOrderToPositionEvent, this);
        DataCache.OnAddTPOrderToPosition.Subscribe(this.onAddTPOrderToPositionEvent, this);
        DataCache.OnRemoveSLOrderFromPosition.Subscribe(this.onRemoveSLOrderFromPositionEvent, this);
        DataCache.OnRemoveTPOrderFromPosition.Subscribe(this.onRremoveTPOrderFromPositionEvent, this);
    }
    unsubscribeEvents() {
        DataCache.OnAddOrder.UnSubscribe(this.onAddOrUpdateOrderEvent, this);
        DataCache.OnUpdateOrder.UnSubscribe(this.onAddOrUpdateOrderEvent, this);
        DataCache.OnRemoveOrder.UnSubscribe(this.onRemoveOrderEvent, this);
        DataCache.OnAddSLOrderToPosition.UnSubscribe(this.onAddSLOrderToPositionEvent, this);
        DataCache.OnAddTPOrderToPosition.UnSubscribe(this.onAddTPOrderToPositionEvent, this);
        DataCache.OnRemoveSLOrderFromPosition.UnSubscribe(this.onRemoveSLOrderFromPositionEvent, this);
        DataCache.OnRemoveTPOrderFromPosition.UnSubscribe(this.onRremoveTPOrderFromPositionEvent, this);
    }
    onAddOrUpdateOrderEvent(order) {
        if (!this.isOrderAllowed(order))
            return;
        this.notifyIfOrderActivated(order);
        const tvOrders = this.convertToTvOrders(order);
        if (tvOrders.length === 0)
            return;
        let hasSl = false;
        let hasTp = false;
        for (const tvOrder of tvOrders) {
            if (!hasSl) {
                hasSl = TvSlTpCache.isSlId(tvOrder.id);
            }
            if (!hasTp) {
                hasTp = TvSlTpCache.isTpId(tvOrder.id);
            }
        }
        const orderId = order.OrderNumber;
        if (!hasSl) {
            // могли удалить sl или sl tr stop, проверяем в кэше
            const slId = TvSlTpCache.getSlId(orderId, false);
            this.tryToRemoveDeletedSlOrder(order, slId, false);
            const slTrStopId = TvSlTpCache.getSlId(orderId, true);
            this.tryToRemoveDeletedSlOrder(order, slTrStopId, true);
        }
        else {
            // могли сменить тип ордера на sl или sl tr stop или наоборот, проверяем
            // hsa: нельзя так делать в этом случае платформа не ловит второй ордер
            // const isTrailingStop = OrderFormatter.IsStopLossTrailingStop(order);
            // const oppositeTrailingStop = !isTrailingStop;
            // const oppositeSlId = this.getSlId(orderId, oppositeTrailingStop);
            // this.tryToRemoveDeletedSlOrder(order, oppositeSlId, oppositeTrailingStop);
        }
        if (!hasTp) {
            if (TvSlTpCache.hasTpPrice(orderId)) {
                const tpId = TvSlTpCache.getTpId(orderId);
                const tpPrice = TvSlTpCache.getTpPrice(orderId);
                const fakeTp = this.createTpBracketWithoutTp(order, tpId, tpPrice);
                this.cancelTvOrder(order, fakeTp);
            }
        }
        for (const tvOrder of tvOrders) {
            this.orderUpdate(order, tvOrder);
        }
    }
    onRemoveOrderEvent(order) {
        if (!this.isOrderAllowed(order))
            return;
        const tvOrders = this.convertToTvOrders(order);
        for (const tvOrder of tvOrders) {
            this.cancelTvOrder(order, tvOrder);
        }
    }
    onAddSLOrderToPositionEvent(position) {
        if (!this.isPositionAllowed(position))
            return;
        const tvSlOrder = this.createSlBracketForPosition(position);
        this.orderUpdate(position.SLOrder, tvSlOrder);
    }
    onAddTPOrderToPositionEvent(position) {
        if (!this.isPositionAllowed(position))
            return;
        const tvTpOrder = this.createTpBracketForPosition(position);
        this.orderUpdate(position.TPOrder, tvTpOrder);
    }
    onRemoveSLOrderFromPositionEvent(position) {
        if (!this.isPositionAllowed(position))
            return;
        const tvSlOrder = this.createSlBracketForPosition(position);
        this.cancelTvOrder(position.SLOrder, tvSlOrder);
    }
    onRremoveTPOrderFromPositionEvent(position) {
        if (!this.isPositionAllowed(position))
            return;
        const tvTpOrder = this.createTpBracketForPosition(position);
        this.cancelTvOrder(position.TPOrder, tvTpOrder);
    }
    createSlBracketForPosition(position) {
        const rSlOrder = position.SLOrder;
        const slOrder = this.createBaseBracketForPosition(position);
        slOrder.id = rSlOrder.OrderNumber;
        slOrder.type = 3 /* tvOrderType.Stop */;
        slOrder.status = this.getTvOrderStatus(rSlOrder);
        slOrder.duration = this.getTvOrderDuration(rSlOrder);
        slOrder.qty = OrderFormatter.Amount(rSlOrder);
        slOrder.filledQty = OrderFormatter.QuantityFilled(rSlOrder);
        const isTrailingStop = rSlOrder.OrderType === OrderType.TrailingStop;
        const slPrice = rSlOrder.Price;
        if (isTrailingStop) {
            slOrder.stopType = 1; // StopType.TrailingStop
            slOrder.stopPrice = slPrice;
            const posOpenPrice = position.Price; // position.CurPriceClose;
            const delta = slPrice - posOpenPrice;
            const ins = position.Instrument;
            const tiks = ins.calculateTicks(posOpenPrice, delta, true);
            slOrder.trailingStopPips = tiks;
        }
        else {
            slOrder.stopPrice = slPrice;
        }
        return slOrder;
    }
    createTpBracketForPosition(position) {
        const rTpOrder = position.TPOrder;
        const tpOrder = this.createBaseBracketForPosition(position);
        tpOrder.id = rTpOrder.OrderNumber;
        tpOrder.type = 1 /* tvOrderType.Limit */;
        tpOrder.status = this.getTvOrderStatus(rTpOrder);
        tpOrder.limitPrice = rTpOrder.Price;
        tpOrder.duration = this.getTvOrderDuration(rTpOrder);
        tpOrder.qty = OrderFormatter.Amount(rTpOrder);
        tpOrder.filledQty = OrderFormatter.QuantityFilled(rTpOrder);
        return tpOrder;
    }
    tryToRemoveDeletedSlOrder(order, slId, isTrailingStop) {
        const orderId = order.OrderNumber;
        if (TvSlTpCache.hasSlPrice(orderId)) {
            let slPrice = NaN;
            let slTrOfset = NaN;
            if (isTrailingStop) {
                [slPrice, slTrOfset] = TvSlTpCache.getSlTrailingStopPrices(order.OrderNumber);
            }
            else {
                slPrice = TvSlTpCache.getSlPrice(order.OrderNumber);
            }
            const fakeSl = this.createSlBracketWithoutSl(order, slId, isTrailingStop, slPrice, slTrOfset);
            this.cancelTvOrder(order, fakeSl);
        }
    }
    cancelTvOrder(rOrder, tvOrder) {
        const status = this.getTvOrderStatus(rOrder);
        if (status === 2 /* tvOrderStatus.Filled */) {
            tvOrder.status = 2 /* tvOrderStatus.Filled */;
        }
        else if (status === 5 /* tvOrderStatus.Rejected */) {
            tvOrder.status = 5 /* tvOrderStatus.Rejected */;
        }
        else {
            tvOrder.status = 1 /* tvOrderStatus.Canceled */;
        }
        this.orderUpdate(rOrder, tvOrder);
        const orderId = tvOrder.id;
        if (TvSlTpCache.isSlId(orderId)) {
            TvSlTpCache.removeSl(orderId);
        }
        else if (TvSlTpCache.isTpId(orderId)) {
            TvSlTpCache.removeTp(orderId);
        }
    }
    createTakeProfitBracket(rOrder) {
        if (!OrderFormatter.HasTakeProfitPrice(rOrder)) {
            return null;
        }
        const id = TvSlTpCache.getTpId(rOrder.OrderNumber);
        const limitPrice = OrderFormatter.TakeProfitPrice(rOrder);
        return this.createTpBracketWithoutTp(rOrder, id, limitPrice);
    }
    createTpBracketWithoutTp(rOrder, tpId, tpPrice) {
        const tpOrder = this.createBaseBracketForOrder(rOrder);
        tpOrder.id = tpId;
        tpOrder.type = 1 /* tvOrderType.Limit */;
        tpOrder.limitPrice = tpPrice;
        return tpOrder;
    }
    createStopLossBracket(rOrder) {
        if (!OrderFormatter.HasStopLossPrice(rOrder)) {
            return null;
        }
        const isTrailingStop = OrderFormatter.IsStopLossTrailingStop(rOrder);
        const id = TvSlTpCache.getSlId(rOrder.OrderNumber, isTrailingStop);
        const price = OrderFormatter.StopLossPrice(rOrder);
        let offset = NaN;
        if (isTrailingStop) {
            offset = rOrder.StopLossPriceValue;
        }
        return this.createSlBracketWithoutSl(rOrder, id, isTrailingStop, price, offset);
    }
    createSlBracketWithoutSl(rOrder, slId, isTrailingStop, slPrice, slOffset = NaN) {
        const slOrder = this.createBaseBracketForOrder(rOrder);
        slOrder.id = slId;
        slOrder.type = 3 /* tvOrderType.Stop */;
        if (isTrailingStop) {
            slOrder.stopType = 1; // StopType.TrailingStop
            slOrder.trailingStopPips = slOffset;
            slOrder.stopPrice = slPrice;
        }
        else {
            slOrder.stopPrice = slPrice;
        }
        return slOrder;
    }
    createBaseBracketForOrder(rOrder) {
        let tvOrdStatus = this.getTvOrderStatus(rOrder);
        if (tvOrdStatus !== 2 /* tvOrderStatus.Filled */ && tvOrdStatus !== 5 /* tvOrderStatus.Rejected */) {
            tvOrdStatus = 3 /* tvOrderStatus.Inactive */;
        }
        const bracketOrder = {
            parentId: rOrder.OrderNumber,
            parentType: 1 /* ParentType.Order */,
            id: rOrder.OrderNumber,
            symbol: this.getSymbol(rOrder),
            type: this.getTvOrderType(rOrder),
            side: this.InvertSide(this.getTvOrderSide(rOrder)),
            qty: OrderFormatter.Amount(rOrder),
            status: tvOrdStatus,
            duration: this.getTvOrderDuration(rOrder)
        };
        return bracketOrder;
    }
    createBaseBracketForPosition(position) {
        const bracketOrder = {
            parentId: position.PositionId,
            parentType: 2 /* ParentType.Position */,
            id: position.PositionId,
            symbol: this.getSymbol(position),
            type: 2 /* tvOrderType.Market */,
            side: this.InvertSide(this.getTvOrderSide(position)),
            qty: position.Amount,
            status: 3 /* tvOrderStatus.Inactive */
        };
        return bracketOrder;
    }
    modifySLOrder(rOrder, slOrder, confirmId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const orderEditBase = this.getOrderTypeObject(rOrder);
            const slTpHolder = this.getSlTpHolder(rOrder);
            const isTrailingStop = slOrder.stopType === 1; // StopType.TrailingStop
            if (isTrailingStop) {
                TvOrdersManager.setSlTrailingStopPrice(slTpHolder, slOrder.trailingStopPips);
            }
            else {
                TvOrdersManager.setSlPrice(slTpHolder, slOrder.stopPrice);
            }
            orderEditBase.setSLTP({ sltpHolder: slTpHolder });
            try {
                yield DataCache.FOrderExecutor.modifyOrderPromise(orderEditBase);
            }
            catch (error) {
                const slError = (_a = orderEditBase.sltp.sl.error) === null || _a === void 0 ? void 0 : _a.toString();
                const rejectedError = isValidString(slError) ? new Error(slError) : error;
                yield Promise.reject(rejectedError);
            }
        });
    }
    modifyTPOrder(tpOrder, confirmId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const rOrder = DataCache.Trading.getOrderById(tpOrder.parentId);
            if (isNullOrUndefined(rOrder)) {
                return;
            }
            const orderEditBase = this.getOrderTypeObject(rOrder);
            const slTpHolder = this.getSlTpHolder(rOrder);
            TvOrdersManager.setTpPrice(slTpHolder, tpOrder.limitPrice);
            orderEditBase.setSLTP({ sltpHolder: slTpHolder });
            try {
                yield DataCache.FOrderExecutor.modifyOrderPromise(orderEditBase);
            }
            catch (error) {
                const tpError = (_a = orderEditBase.sltp.tp.error) === null || _a === void 0 ? void 0 : _a.toString();
                const rejectedError = isValidString(tpError) ? new Error(tpError) : error;
                yield Promise.reject(rejectedError);
            }
        });
    }
    cancelSlOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve, reject) => {
                const rOrderId = TvSlTpCache.removeSlSuffix(orderId);
                const rOrder = DataCache.Trading.getOrderById(rOrderId);
                if (!rOrder) {
                    return;
                }
                const fakeSl = this.createStopLossBracket(rOrder);
                const orderEditBase = this.getOrderTypeObject(rOrder);
                const slTpHolder = this.getSlTpHolder(rOrder);
                this.removeSlPrice(slTpHolder);
                orderEditBase.setSLTP({ sltpHolder: slTpHolder });
                void DataCache.FOrderExecutor.modifyOrderPromise(orderEditBase);
                this.cancelTvOrder(rOrder, fakeSl); // TODO Check reject
                resolve();
            });
        });
    }
    cancelTpOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve, reject) => {
                const rOrderId = TvSlTpCache.removeTpSuffix(orderId);
                const rOrder = DataCache.Trading.getOrderById(rOrderId);
                if (!rOrder) {
                    return;
                }
                const fakeTp = this.createTakeProfitBracket(rOrder);
                const orderEditBase = this.getOrderTypeObject(rOrder);
                const slTpHolder = this.getSlTpHolder(rOrder);
                this.removeTpPrice(slTpHolder);
                orderEditBase.setSLTP({ sltpHolder: slTpHolder });
                void DataCache.FOrderExecutor.modifyOrderPromise(orderEditBase);
                this.cancelTvOrder(rOrder, fakeTp); // TODO Check reject
                resolve();
            });
        });
    }
    getOrderTypeObject(order) {
        const orderTypeObj = DataCache.OrderParameterContainer.GetOrderType(order.OrderType);
        const orderEdit = orderTypeObj.createModifyOrderObject({
            dataCache: DataCache,
            order
        });
        orderEdit.placedFrom = PlacedFrom.TV_TRADING_PLATFORM_OTHER;
        return orderEdit;
    }
    static createOrderEditBase(preOrder, account) {
        const orderType = TvOrderConvertor.getRealOrderType(preOrder.type);
        const type = DataCache.OrderParameterContainer.GetOrderType(orderType);
        const orderEditBase = type.createOrderEditObject({ dataCache: DataCache });
        TvOrdersManager.fillOrderEditBase(orderEditBase, account, preOrder, new SlTpHolder());
        return orderEditBase;
    }
    static fillOrderEditBase(orderEditBase, account, preModOrder, sltpHolder) {
        const side = preModOrder.side === 1 /* Side.Buy */ ? OperationType.Buy : OperationType.Sell;
        const orderEditData = TvOrdersManager.getOrderEditData(account, preModOrder, side);
        orderEditBase.updateParameters(new OrderEditUpdateData(null, orderEditData));
        if (preModOrder.takeProfit) {
            TvOrdersManager.setTpPrice(sltpHolder, preModOrder.takeProfit);
        }
        if (preModOrder.trailingStopPips) {
            TvOrdersManager.setSlTrailingStopPrice(sltpHolder, preModOrder.trailingStopPips);
        }
        else if (preModOrder.stopLoss) {
            TvOrdersManager.setSlPrice(sltpHolder, preModOrder.stopLoss);
        }
        if (preModOrder.limitPrice)
            orderEditBase.setBasePrice(preModOrder.limitPrice, true);
        if (preModOrder.stopPrice)
            orderEditBase.setStopPrice(preModOrder.stopPrice, false);
        orderEditBase.setSLTP({ sltpHolder });
        orderEditBase.placedFrom = PlacedFrom.TV_TRADING_PLATFORM_OE;
    }
    static getOrderEditData(account, preModOrder, side) {
        const interiorId = TvInteriorIdCache.getInteriorId(preModOrder.symbol);
        const rInstrument = DataCache.getInstrumentByName(interiorId);
        const tifId = OrderTif[preModOrder.duration.type];
        const tif = new TIF(tifId);
        const gtdExpirationTime = preModOrder.duration.datetime;
        if (!isNullOrUndefined(gtdExpirationTime)) {
            tif.expirationTime = new Date(gtdExpirationTime);
        }
        const orderEditData = {
            account,
            instrument: rInstrument,
            side,
            quantity: new Quantity(preModOrder.qty, true),
            tif,
            productType: ProductType.General
        };
        return orderEditData;
    }
    getSlTpHolder(rOrder) {
        const slTpHolder = new SlTpHolder();
        if (OrderFormatter.HasStopLossPrice(rOrder)) {
            if (OrderFormatter.IsStopLossTrailingStop(rOrder)) {
                slTpHolder.StopLossPriceType = SlTpPriceType.TrOffset;
                slTpHolder.StopLossPriceValue = rOrder.StopLossPriceValue;
            }
            else {
                slTpHolder.StopLossPriceType = SlTpPriceType.Absolute;
                slTpHolder.StopLossPriceValue = OrderFormatter.StopLossPrice(rOrder);
            }
        }
        if (OrderFormatter.HasTakeProfitPrice(rOrder)) {
            slTpHolder.TakeProfitPriceType = SlTpPriceType.Absolute;
            slTpHolder.TakeProfitPriceValue = OrderFormatter.TakeProfitPrice(rOrder);
        }
        return slTpHolder;
    }
    static setSlPrice(sltpHolder, price) {
        sltpHolder.StopLossPriceType = SlTpPriceType.Absolute;
        sltpHolder.StopLossPriceValue = price;
    }
    static setTpPrice(sltpHolder, price) {
        sltpHolder.TakeProfitPriceType = SlTpPriceType.Absolute;
        sltpHolder.TakeProfitPriceValue = price;
    }
    static setSlTrailingStopPrice(sltpHolder, ticks) {
        sltpHolder.StopLossPriceType = SlTpPriceType.TrOffset;
        sltpHolder.StopLossPriceValue = ticks;
    }
    removeSlPrice(sltpHolder) {
        TvOrdersManager.setSlPrice(sltpHolder, NaN);
    }
    removeTpPrice(sltpHolder) {
        TvOrdersManager.setTpPrice(sltpHolder, NaN);
    }
    orderUpdate(rOrder, tvOrder) {
        this.host.orderUpdate(tvOrder);
        this.orderPartialUpdate(rOrder, tvOrder);
    }
    orderPartialUpdate(rOrder, tvOrder) {
        var _a, _b;
        const bracket = tvOrder; /// ???
        if (isNullOrUndefined(bracket)) {
            return;
        }
        const isSlOrTp = TvSlTpCache.isSlId(tvOrder.id) || TvSlTpCache.isTpId(tvOrder.id);
        const qtyRem = OrderFormatter.QuantityRemaining(rOrder);
        tvOrder.qtyrem = qtyRem > 0 ? qtyRem : 0;
        tvOrder.last = OrderFormatter.CurrentPrice(rOrder);
        tvOrder.tif = OrderFormatter.ValidityStr(rOrder);
        if (!isSlOrTp && OrderFormatter.HasStopLossPrice(rOrder)) {
            tvOrder.stopLoss = OrderFormatter.StopLossPrice(rOrder);
        }
        if (!isSlOrTp && OrderFormatter.HasTakeProfitPrice(rOrder)) {
            tvOrder.takeProfit = OrderFormatter.TakeProfitPrice(rOrder);
        }
        tvOrder.filledQty = OrderFormatter.QuantityFilled(rOrder);
        const lastUpdateTime = Math.max((_b = (_a = rOrder.LastUpdateTime) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0, rOrder.UTCDateTime.getTime());
        tvOrder.date = { dateOrDateTime: lastUpdateTime, hasTime: true };
        this.host.orderPartialUpdate(tvOrder.id, tvOrder);
    }
    notifyIfOrderActivated(rOrder) {
        if (rOrder.ExecutionType !== OrderExecutionType.ACTIVATED)
            return;
        const ordTypeStr = Resources.getResourceLang(`property.${OrderUtils.getOrderTypeLocalizationKey(rOrder.OrderType)}`, LOCALE_EN);
        const header = Resources.getResource(`${ordTypeStr} order activated`);
        const text = `${header} ${rOrder.OrderNumber}`;
        this.host.showNotification(header, text, 1 /* NotificationType.Success */);
    }
    isOrderAllowed(rOrder) {
        if (rOrder.Account !== TvAccountHelper.getCurrentAccount())
            return false;
        return TvDurationConvertor.getAllAlowedOrderTypes().includes(rOrder.OrderType);
    }
    isPositionAllowed(position) {
        return position.Account === TvAccountHelper.getCurrentAccount();
    }
    isValidPositionBrackets(position, tvOrder) {
        const isTp = tvOrder.type === 1 /* tvOrderType.Limit */;
        const rOrder = isTp ? position.TPOrder : position.SLOrder;
        if (isNullOrUndefined(rOrder)) {
            console.warn(`Position bracket not found for PositionID: ${position.PositionId} Bracket OrderID: ${tvOrder.id}`);
            return false;
        }
        const duration = this.getTvOrderDuration(rOrder);
        const qty = OrderFormatter.Amount(rOrder);
        if (tvOrder.qty !== qty)
            return false;
        if (tvOrder.duration.type !== duration.type)
            return false;
        if (tvOrder.duration.datetime !== duration.datetime)
            return false;
        return true;
    }
    isValidOrderBrackets(rOrder, tvOrder) {
        const duration = this.getTvOrderDuration(rOrder);
        const qty = OrderFormatter.Amount(rOrder);
        if (tvOrder.qty !== qty)
            return false;
        if (tvOrder.duration.type !== duration.type)
            return false;
        if (tvOrder.duration.datetime !== duration.datetime)
            return false;
        return true;
    }
    // #region IDestroyable
    destroy() {
        this.unsubscribeEvents();
    }
}
// There is no public access to this enum in TV API
var OrderOrPositionMessageType;
(function (OrderOrPositionMessageType) {
    OrderOrPositionMessageType["Information"] = "information";
    OrderOrPositionMessageType["Warning"] = "warning";
    OrderOrPositionMessageType["Error"] = "error";
})(OrderOrPositionMessageType || (OrderOrPositionMessageType = {}));
